import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { prepareFilters } from '../../components/Filters/request';
import { fetch, handleErrors } from '../../api';
import api from '../../api/endpoints';

function* generateAnalyticsLinksReport({ payload: { filters, curr_page } }) {
  try {
    const { data } = yield call(fetch, { api: api.analytics.links_report, data: { ...prepareFilters(filters), page: curr_page } });

    yield put(actions.generateAnalyticsLinksReportDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.generateAnalyticsLinksReportFailed,
      endpoint: api.analytics.links_report.url
    });
  }
}

export const generateAnalyticsLinksReportSaga = takeEvery(types.GENERATE_ANALYTICS_LINKS_REPORT_REQUEST, generateAnalyticsLinksReport);


